import React, { Component } from 'react';
import './App.css';


// eslint-disable-next-line
class Url extends Component {
  render() { 
    return (
	<div className="Url">
	<a href={this.props.url}>{this.props.url}</a>
	</div>
	);
  }
}
// eslint-disable-next-line
class LinkDescription extends Component {
  render() { 
    return (
	<div className="LinkDescription">
	{this.props.linkDescription}
	</div>
	);
  }
}

// This will be used to show top info 
// Name, Address, Phone, Email.


class Link extends Component {
   render() { 
     return (
	 <div className="Links">
	 Links
	 {this.props.children}
	 </div>
     );
   }
}

export default Link;



// WEBPACK FOOTER //
// ./src/Link.js